var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.375 12.739L10.682 20.432C9.83811 21.2759 8.69351 21.75 7.50003 21.75C6.30655 21.75 5.16195 21.2759 4.31803 20.432C3.47411 19.5881 3 18.4435 3 17.25C3 16.0565 3.47411 14.9119 4.31803 14.068L15.258 3.12801C15.5367 2.84948 15.8675 2.62856 16.2315 2.47787C16.5956 2.32718 16.9857 2.24966 17.3797 2.24976C17.7737 2.24985 18.1639 2.32754 18.5278 2.47841C18.8918 2.62927 19.2225 2.85035 19.501 3.12901C19.7796 3.40768 20.0005 3.73847 20.1512 4.10252C20.3019 4.46656 20.3794 4.85672 20.3793 5.25072C20.3792 5.64472 20.3015 6.03484 20.1506 6.39881C19.9998 6.76278 19.7787 7.09348 19.5 7.37201L8.55203 18.32C8.26801 18.5923 7.88839 18.7411 7.49497 18.7361C7.10156 18.7311 6.72585 18.5717 6.44883 18.2924C6.1718 18.013 6.01564 17.6359 6.01399 17.2425C6.01234 16.849 6.16535 16.4707 6.44003 16.189L14.25 8.37901M8.56103 18.31L8.55103 18.32",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.d8ae0955497a6aadff04971c7086c154.svg";
export { ForwardRef as ReactComponent };